/**
 * URL-safe reference for a supplier name. Mirrors buyer-service's
 * supplierPackageService.supplierSlug so the per-supplier RFQ download
 * addresses the same supplier the server resolves.
 */
export const supplierSlug = (name: string): string =>
  name
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
